import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";

var HeartsAnimate =
/*#__PURE__*/
function (_Vue) {
  _inherits(HeartsAnimate, _Vue);

  function HeartsAnimate() {
    _classCallCheck(this, HeartsAnimate);

    return _possibleConstructorReturn(this, _getPrototypeOf(HeartsAnimate).apply(this, arguments));
  }

  return HeartsAnimate;
}(Vue);

HeartsAnimate = tslib_1.__decorate([Component({
  components: {}
})], HeartsAnimate);
export default HeartsAnimate;